<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div v-if="!projectId" class="full-height-page-wrapper">
          <PageHeader showBreadcrumbs :page-title="'Hours and payments reports'" />
          <div v-if="getProjects.length" class="d-flex justify-content-start bg-white p-4">
            <multiselect class="multiselect-projects" v-model="currentProject" :options="getProjects"
              :placeholder="'Select project'" :track-by="'name'" :label="'name'" :allow-empty="false"
              :showLabels="false" @select="getProjectPage" />
          </div>
          <div v-else class="full-height-content">
            <EmptyStateNoResults
              title="No hours and payments report yet"
              description="No projects available. Once created, the report will appear here."
              customIcon="hourglass_bottom"
              customIconClasses="material-symbols-outlined empty-state__icon"
              :withoutButton="true"
            />
          </div>
        </div>
        <template v-else>
          <TableWithDetails v-if="getCurrentProject" :key="projectId" :current-project="getCurrentProject"
            :projects-list="getProjects" @changeProject="getProjectPage($event)" />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TableWithDetails from '@components/tables/TableWithDetails'
import PageHeader from '@components/PageHeader'
import EmptyStateNoResults from '@components/EmptyStateNoResults.vue'

export default {
  components: {
    PageHeader,
    TableWithDetails,
    EmptyStateNoResults
  },
  data () {
    return {
      projectId: null,
      currentProject: null
    }
  },
  created () {
    if (!this.getProjects.length) {
      this.$api.projects.getProjects()
    }

    this.$watch(
      () => this.$route.params,
      (toParams) => {
        this.projectId = toParams.id
        this.$forceUpdate()
      }
    )
  },
  mounted () {
    if (this.$route.params.id) {
      this.projectId = this.$route.params.id
    } else {
      this.projectId = null
      this.currentProject = null
    }
  },
  computed: {
    ...mapGetters({
      getProjects: 'projects/getProjects'
    }),
    getCurrentProject () {
      if (this.projectId) {
        return this.getProjects.find(project => project.id === +this.projectId)
      }

      return this.currentProject
    }
  },
  methods: {
    getProjectPage (data) {
      this.$router.push({ name: 'h-p-report', params: { id: data.id } })
      this.projectId = data.id
    }
  }
}
</script>

<style lang="scss" scoped>
.multiselect-projects {
  width: 200px;
}
</style>
